import parse, { Element } from 'html-react-parser';
import Image from 'next/image';
import sanitizeHtml from 'sanitize-html';

import { VideoPlayer } from '@/features/articles/components/renderers/VideoPlayer';
import styles from './Article.module.css';

export const renderContent = (content: string) => {
  return parse(
    sanitizeHtml(content, {
      allowedTags: [
        ...sanitizeHtml.defaults.allowedTags,
        'img',
        'video',
        'audio',
        'track',
        'source',
      ],
      allowedAttributes: {
        ...sanitizeHtml.defaults.allowedAttributes,
        video: [
          'src',
          'controls',
          'autoplay',
          'muted',
          'loop',
          'width',
          'height',
        ],
        audio: [
          'src',
          'controls',
          'autoplay',
          'muted',
          'loop',
          'preload',
          'class',
        ],
      },
    }),
    {
      replace: (node) => {
        if (node instanceof Element) {
          if (node.name === 'video' && node.attribs.src) {
            return <VideoPlayer src={node.attribs.src} />;
          }
          if (node.name === 'audio' && node.attribs.src) {
            return (
              // oxlint-disable-next-line jsx-a11y/media-has-caption
              <audio
                src={node.attribs.src}
                className={styles.contentAudio}
                preload="auto"
                controls
              />
            );
          }

          if (node.name === 'img' && node.attribs.src) {
            return (
              <span className={styles.contentImageWrapper}>
                <Image
                  src={node.attribs.src}
                  fill
                  sizes="100vw"
                  alt=""
                  loading="lazy"
                />
              </span>
            );
          }
        }
      },
    }
  );
};
